import { Link, useRouterState } from "@tanstack/react-router";
import { MailWarning } from "lucide-react";

import { useSession } from "@/app/session";
import { usePlatform, type Account } from "@/pages/account/platform";

/**
 * "Confirm your email" until the user enters the emailed code. The session
 * says whether to look; /platform/me says whether it's still unconfirmed (it
 * updates the moment the Account page confirms it).
 */
export function EmailBanner() {
  const session = useSession();
  const path = useRouterState({ select: (s) => s.location.pathname });
  const maybe = session.user?.email_verified === false;
  const me = usePlatform<Account>("/platform/me", undefined, maybe);
  if (!maybe || !me.data || me.data.email_verified || path === "/app/account")
    return null;
  return (
    <div className="border-b border-warn/30 bg-warn-soft px-4 py-2 text-xs text-fg sm:px-5">
      <div className="mx-auto flex max-w-[1600px] flex-wrap items-center gap-x-2 gap-y-1">
        <MailWarning className="size-4 shrink-0 text-warn" aria-hidden />
        <span className="min-w-0">
          Confirm your email: enter the code we sent to{" "}
          <span className="font-medium break-words">{me.data.email}</span>, so
          alert emails and receipts reach you.
        </span>
        <Link
          to="/app/account"
          className="font-medium text-brand hover:underline"
        >
          Enter the code
        </Link>
      </div>
    </div>
  );
}
